module.exports = __webpack_public_path__ + "img/icon-add.6193419f.svg";